import React from 'react'
import { FaFacebook,FaInstagram } from 'react-icons/fa';
import { GiSpiralBottle } from 'react-icons/gi';
export default function Feature() {
  return (
    <div>

<section className="text-gray-600 body-font" style={{background:"#FFCF00"}}>
  <div className="container px-5  py-10 mx-auto" >
    
    <div className="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4 md:space-y-0 space-y-6">
      <div className="p-4 md:w-1/4   flex flex-col text-center items-center">
      <div style={{background:"#495055"}} className="w-20 h-20 transition ease-in-out delay-150 text-orange-500 hover:text-white duration-300  inline-flex cursor-pointer items-center justify-center rounded-full  text-indigo-500 mb-5 flex-shrink-0">
        <GiSpiralBottle size={40}     />
        </div>
        <div className="flex-grow">
          <h2 className="text-gray-900 text-2xl title-font font-serif  font-bold  mb-3 hover:text-orange-300 transition ease-in-out delay-150 duration-300">
            Shooting Stars 
            <div className='flex justify-center'>
            <h2  style={{width:"40px"}} className=' border-b-2    border-b-gray-500'></h2>
            </div>
          </h2>
          <p className="leading-relaxed text-base">
            Blue bottle crucifix vinyl post-ironic four dollar toast vegan
          
          </p>
         
        </div>
      </div>
      <div className="p-4 md:w-1/4 flex flex-col text-center items-center">
      <div style={{background:"#495055"}} className="w-20 h-20 transition ease-in-out delay-150 text-orange-500 hover:text-white duration-300  inline-flex cursor-pointer items-center justify-center rounded-full  text-indigo-500 mb-5 flex-shrink-0">
        <GiSpiralBottle size={40}     />
        </div>
        <div className="flex-grow">
          <h2 className="text-gray-900 text-2xl title-font font-serif  font-bold mb-3 hover:text-orange-300 transition ease-in-out delay-150 duration-300">
            The Catalyzer
            <div className='flex justify-center'>
            <h2  style={{width:"40px"}} className=' border-b-2    border-b-gray-500'></h2>
            </div>
          </h2>
          
          <p className="leading-relaxed text-base">
            Blue bottle crucifix vinyl post-ironic four dollar toast vegan
           
          </p>
         
        </div>
      </div>
      <div className="p-4 md:w-1/4 flex flex-col text-center items-center">
      <div style={{background:"#495055"}} className="w-20 h-20 transition ease-in-out delay-150 text-orange-500 hover:text-white duration-300  inline-flex cursor-pointer items-center justify-center rounded-full  text-indigo-500 mb-5 flex-shrink-0">
        <GiSpiralBottle size={40}     />
        </div>
        <div className="flex-grow">
          <h2 className="text-gray-900 text-2xl title-font font-serif  font-bold mb-3 hover:text-orange-300 transition ease-in-out delay-150 duration-300">
            Neptune
            <div className='flex justify-center'>
            <h2  style={{width:"40px"}} className=' border-b-2    border-b-gray-500'></h2>
            </div>
          </h2>
          <p className="leading-relaxed text-base">
            Blue bottle crucifix vinyl post-ironic four dollar toast vegan
            
          </p>
         
        </div>
      </div>
      <div className="p-4 md:w-1/4 flex flex-col text-center items-center">
      <div style={{background:"#495055"}} className="w-20 h-20 transition ease-in-out delay-150 text-orange-500 hover:text-white duration-300  inline-flex cursor-pointer items-center justify-center rounded-full  text-indigo-500 mb-5 flex-shrink-0">
        <GiSpiralBottle size={40}     />
        </div>
        <div className="flex-grow">
          <h2 className="text-gray-900 text-2xl title-font font-serif  font-bold mb-3 hover:text-orange-300 transition ease-in-out delay-150 duration-300 ">
            Neptune
            <div className='flex justify-center'>
            <h2  style={{width:"40px"}} className=' border-b-2    border-b-gray-500'></h2>
            </div>
          </h2>
          <p className="leading-relaxed text-base">
            Blue bottle crucifix vinyl post-ironic four dollar toast vegan
            
          </p>
         
        </div>
      </div>
    </div>
   
  </div>
</section>


    </div>
  )
}
